import memoize from 'lodash/memoize';
import type { TBookAlias } from '@shared/jp/product';
import Books from './index';
import Gift from './Gift';

export const getBookByAlias = memoize((alias: TBookAlias) => {
  if (alias === Gift.alias) {
    return Gift;
  }

  const book = Books.find((b) => b.alias === alias);

  if (!book)
    throw new Error(
      `book not found by alias "${alias}", probably use USER_PROJECT_BOOKS injection token`,
    );

  return book;
});
